import {
  getArrayOfValuesFromArray,
  getItemFromArray,
} from "lib/utils/array-utils";
import { formatRoomNumber } from "lib/utils/util";
import { FC } from "react";
import SimpleDropdown from "../simple-dropdown";
import { ALL } from "lib/constants";
import {
  ALL_ROOM_DETAILS,
  DEFAULT_ROOM_DETAILS,
} from "lib/constants/default-values";

interface ClinicRoomsDropdownProps {
  className?: string;
  clinicRooms: RoomDetails[];
  label?: string;
  parentClassName?: string;
  selectedRoom: RoomDetails | null;
  isShowAll?: boolean;

  onRoomChange: (room: RoomDetails | null) => void;
}

const ClinicRoomsDropdown: FC<ClinicRoomsDropdownProps> = ({
  className,
  parentClassName,
  label = "Rooms",
  clinicRooms,
  selectedRoom,
  isShowAll,
  onRoomChange,
}) => {
  const roomOptions = getArrayOfValuesFromArray(clinicRooms, "roomNumber").map(
    (roomNumber) => formatRoomNumber(roomNumber)
  );
  const roomValues = getArrayOfValuesFromArray(clinicRooms, "id");

  const handleChange = (value: string) => {
    if (value.localeCompare(ALL) === 0) {
      onRoomChange(ALL_ROOM_DETAILS());
      return;
    }
    const room = getItemFromArray(clinicRooms, "id", value);
    onRoomChange(room || null);
  };

  return (
    <SimpleDropdown
      parentClassName={`mb-0 ${parentClassName}`}
      label={label}
      className={`simple-dropdown ${className}`}
      showAllTitle={isShowAll && ALL}
      showAllValue={isShowAll && ALL}
      options={Array.from(
        new Set(roomOptions.length > 0 ? roomOptions : ["No Rooms Available"])
      )}
      selectedValue={selectedRoom?.id}
      values={Array.from(new Set(roomValues))}
      onSelectValue={handleChange}
    />
  );
};

export default ClinicRoomsDropdown;
